import { memo } from 'react'

import {
  WithFormControlSelect,
  type IWithFormControlSelect,
} from '@procurify/ui'

import {
  PDFLabelSetSelect,
  type IPDFLabelSetSelectProps,
} from './PDFLabelSetSelect'

export interface IPDFLabelSetFormSelectProps
  extends
    Omit<IWithFormControlSelect, 'children'>,
    Omit<IPDFLabelSetSelectProps, 'id' | 'name'> {
  id: string
  name: string
}

export const PDFLabelSetFormSelect = memo(
  ({
    name,
    disabled,
    id,
    label,
    labelIcon,
    labelTooltipMessage,
    labelTooltipAriaLabel,
    helperText,
    required,
    fullWidth = true,
    ...pdfLabelSetSelectProps
  }: IPDFLabelSetFormSelectProps) => {
    return (
      <WithFormControlSelect
        name={name}
        disabled={disabled}
        id={id}
        label={label}
        labelIcon={labelIcon}
        labelTooltipMessage={labelTooltipMessage}
        labelTooltipAriaLabel={labelTooltipAriaLabel}
        helperText={helperText}
        required={required}
        fullWidth={fullWidth}
      >
        <PDFLabelSetSelect {...pdfLabelSetSelectProps} />
      </WithFormControlSelect>
    )
  }
)

PDFLabelSetFormSelect.displayName = 'PDFLabelSetFormSelect'
